import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ItemChecklist } from '../classes/ItemChecklist';


@Injectable({
  providedIn: 'root'
})
export class ItemChecklistService {

  constructor(private http: HttpClient) { }

  route = "ItemChecklist";

  Listar(checklistId: number): Observable<any>{
    return this.http.get(`${environment.apiURL}/${this.route}/ListarPorChecklistId/${checklistId}`)
  }

  ObterPorId(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/${this.route}/ObterPorId/${id}`)
  }

  Inserir(obj: ItemChecklist): Observable<any>{
    return this.http.post(`${environment.apiURL}/${this.route}`, obj);
  }

  Atualizar(id: number, obj: ItemChecklist): Observable<any>{
    return this.http.put(`${environment.apiURL}/${this.route}/${id}`, obj);
  }

  Excluir(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/${this.route}/${id}`);
  }

}
